export default [
  'chat/[chatId]/info',
  'chat/hidden',
  'chat/create/direct',
  'chat/create/group',
  'chat/[chatId]/message/[messageId]/reactions',
  'event/share',
  'event/action',
  'event/[eventId]/edit',
  'event/[eventId]/events/action',
  'event/[eventId]/events/share',
  'event/[eventId]/standings/share',
  'event/[eventId]/stats/share',
  'event/[eventId]/rsvp',
  'event/[eventId]/rsvp-note',
  'event/[eventId]/notes',
  'event/[eventId]/scorekeeping/delete',
  'event/[eventId]/scorekeeping/score',
  'event/[eventId]/scorekeeping/assignment',
  'event/create',
  'event/[eventId]/generate',
  'badge-assignee/[assigneeId]',
  'badge-assignee/create',
  'badge/create',
  'badge/[badgeId]',
  'member-action',
  'organization/join',
  'organization/[organizationId]/edit',
  'profile',
  'person/[personId]',
  'team/create',
  'team/join',
  'team/[teamId]/edit',
  'team/[teamId]/person/add',
  'team/[teamId]/member/[personId]',
  'organization/[organizationId]/person/add',
  'organization/[organizationId]/member/[personId]',
];
